export default {
  messages: {
    en: {
      //
    },
  },
}
